/*=========================================================================================
  File Name: module-taxdec-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
	resetState(state) {
		//Object.assign(state, defaultAuthState);
	},
	updateNoti(state, res) {
		state.SystemNoti.removeAll();
		state.SystemNoti.append(res.Data);
	}
};
